const PreHandlers = new Map();

export { PreHandlers };
//# sourceMappingURL=pre-handler-registry.js.map
